<template>
  <smartLogisticsRule :pageType="'distributor'"></smartLogisticsRule>
</template>

<script>
import Mixin from '@/components/mixin/common_mixin';
import smartLogisticsRule from "@/views/yms/components/logisticsManage/smartLogisticsRule";

export default {
  name: 'smartRule',
  mixins: [Mixin],
  components: {
    smartLogisticsRule
  },
  data() {
    return {};
  },
  created() {

  },
  props: {},
  watch: {},
  methods: {}
};
</script>

<style scoped>

</style>
